/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Action_Bar_PlannedInputs */



/**
* | output |
* | --- |
* | "Configure settings, then open registration." |
*
* @param {Action_Bar_PlannedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const action_bar_planned = /** @type {((inputs?: Action_Bar_PlannedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Action_Bar_PlannedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Configurez les paramètres, puis ouvrez les inscriptions.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Configure los ajustes y luego abra las inscripciones.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Configure as definições e depois abra as inscrições.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Configura le impostazioni, poi apri le iscrizioni.")
	return /** @type {LocalizedString} */ ("Configure settings, then open registration.")
});